module.exports = __webpack_public_path__ + "img/bramble.93e1a10d.jpg";